export const SPEND_CONTROL_LIMIT_FIELD = 'amountLimit'
export const SPEND_CONTROL_FREQUENCY_FIELD = 'velocityWindow'
export const SPEND_CONTROL_MAXIMUM_TRANSACTION_LIMIT_FIELD =
  'maxTransactionValue'

export const SPEND_CONTROL_LIMIT_MIN_VALUE = 1
export const SPEND_CONTROL_MAX_TRANSACTION_LIMIT_MAX_VALUE = 25000
export const SPEND_CONTROL_MAX_TRANSACTION_LIMIT_MIN_VALUE = 1
